import { z } from '@harvestiq/zod';
import { dbSigningAgentSchema } from './db-signing-agent';

export const signingAgentSchema = dbSigningAgentSchema.extend({
  fullName: z.string().optional(),
});
export type SigningAgent = z.infer<typeof signingAgentSchema>;
